import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from './Responses';
import { ISchedulerWorkHours } from "../models/ISchedulerWorkHours";
import { IMultiplayDayModel } from "../models/IMultiplyDayModel";
import { IMultiplyWeekModel } from "../models/IMultiplyWeekModel";
import { IVisitInfo } from "../models/IVisitInfo";
import { IAddFixedWorkHoursModel } from "../models/IAddFixedWorkHoursModel";
import { IClinicListItem } from "../models/IClinicListItem";
import { IVisitListFilters } from "../models/IVisitListFilters";
import { ITimeTableCriteria } from "../models/ITimeTableCriteria";
import { IAverageVisitDuration } from '../models/IAverageVisitDuration';
import { IHolidays } from '../models/IHolidays';

export class SchedulerService extends AbstractApiService {
    constructor() {
        super();
    }

    public MyWorkHours(dateFrom: Date, dateTo: Date, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/myworkhours?dateFrom='
            + encodeURI(dateFrom.toISOString())
            + '&dateTo='
            + encodeURI(dateTo.toISOString()),
            onSuccess,
            onError);
    }
    
    public MyVisits(dateFrom: Date, dateTo: Date, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/myvisits?dateFrom='
            + encodeURI(dateFrom.toISOString())
            + '&dateTo='
            + encodeURI(dateTo.toISOString()),
            onSuccess,
            onError);
    }

    public SearchVisits(searchValue: string, dateFrom: Date, dateTo: Date, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/searchvisits?searchValue='
            + encodeURI(searchValue)
            + '&dateFrom='
            + encodeURI(dateFrom.toISOString())
            + '&dateTo='
            + encodeURI(dateTo.toISOString()),
            onSuccess,
            onError);
    }

    public AddMyWorkHours(workHours: ISchedulerWorkHours, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/addmyworkhours', workHours, onSuccess, onError);
    }

    public EditMyWorkHours(workHours: ISchedulerWorkHours, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/editmyworkhours', workHours, onSuccess, onError);
    }

    public DeleteMyWorkHours(workHoursId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/deletemyworkhours', workHoursId, onSuccess, onError);
    }

    public MultiplyDay(multiplyModel: IMultiplayDayModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/multiplyworkday', multiplyModel, onSuccess, onError);
    }

    public MultiplyWeek(multiplyModel: IMultiplyWeekModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/multiplyworkweek', multiplyModel, onSuccess, onError);
    }

    public GetTimeTable(physiotherapistId: string,
        clinicId: number,
        dateFrom,
        dateTo,
        onSuccess: OnRequestSuccess,
        onError: OnRequestError
    ) {
        this.Get('api/scheduler/gettimetable?physiotherapistId='
            + physiotherapistId.toString()
            + '&clinicId='
            + clinicId.toString()
            + '&dateFrom='
            + encodeURI(dateFrom.toISOString())
            + '&dateTo='
            + encodeURI(dateTo.toISOString()),
            onSuccess,
            onError);
    }
    
    public ArrangePhysiotherapistVisit(model: IVisitInfo, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/arrangephysiotherapistvisit', model, onSuccess, onError);
    }

    public ArrangeAnonymousVisit(model: IVisitInfo, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/arrangeanonymousvisit', model, onSuccess, onError);
    }

    public ArrangeCustomerVisit(model: IVisitInfo, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/arrangecustomervisit', model, onSuccess, onError);
    }

    public ArrangeVisitSmsConfirm(smsCode: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/arrangevisitsmsconfirm', smsCode, onSuccess, onError);
    }

    public GetMyFixedWorkHours(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/getmyfixedworkhours', onSuccess, onError);
    }

    public AddMyFixedWorkHours(model: IAddFixedWorkHoursModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/addmyfixedworkhours', model, onSuccess, onError);
    }

    public DeleteMyFixedWorkHours(fixedWorkHoursId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/deletemyfixedworkhours', fixedWorkHoursId, onSuccess, onError);
    }
    
    public ModifyMyFixedWokHours(modifyModel: IAddFixedWorkHoursModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/modifymyfixedworkhours', modifyModel, onSuccess, onError);
    }

    public SetClinicsSchedulerColor(model: IClinicListItem, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/setclinicschedulercolor', model, onSuccess, onError);
    }

    public GetMyVisitsList(filters: IVisitListFilters, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/myvisitslist', filters, onSuccess, onError);
    }

    public GetMyVisitsListPdf(filters: IVisitListFilters, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/myvisitlistfilters', filters, onSuccess, onError);
    }

    public GetCustomerVisitsList(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/customervisitlist', onSuccess, onError);
    }

    public GetTimeTableForSearch(criteria: ITimeTableCriteria, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/gettimetableforsearch', criteria, onSuccess, onError);
    }

    public GetVisit(visitId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/getvisitforview?visitId=' + visitId, onSuccess, onError);
    }

    public GetVisitAnonymous(visitId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/getvisitforviewanonymous?visitId=' + visitId, onSuccess, onError);
    }

    public AbortVisit(visitId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/abortvisit?visitId=' + visitId, onSuccess, onError);
    }

    public AbortVisitAnonymous(visitId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/abortvisitanonymous?visitId=' + visitId, onSuccess, onError);
    }
    
    public SetVisitCompleted(visitId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/setvisitcompleted?visitId=' + visitId, onSuccess, onError);
    }

    public MyVisitTherapies(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/myvisittherapies', onSuccess, onError);
    }

    public AddVisitToCalendar(visitId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/addvisittocalendar?visitId=' + visitId, onSuccess, onError);
    }

    public SendConfirmCode(phone: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/confirmcode', phone, onSuccess, onError);
    }

    public RegenerateConfirmCode(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/regenerateconfirmcode', onSuccess, onError);
    }

    public PhysiotherapistHasAnyWorkHours(onSuccess: OnRequestSuccess, onError: OnRequestError, physiotherapistId?: number) {
        this.Get('api/scheduler/physiotherapisthasanyworkhours?physiotherapistId=' + physiotherapistId, onSuccess, onError);
    }

    public GetVisitListInitialData(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/getvisitlistinitialdata', onSuccess, onError);
    }

    public RequestSchedulerActivation(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/requestscheduleractivation?physiotherapistId=' + physiotherapistId, onSuccess, onError);
    }
    
    public GetClosestAvailableVisitDate(physiotherapistId: string, clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/getclosestavailablevisitdate?physiotherapistId=' + physiotherapistId
            + '&clinicId=' + clinicId.toString(), onSuccess, onError);
    }
    
    public GetAverageVisitDurations(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/myaveragevisitdurations', onSuccess, onError);
    }
    
    public SetMyAverageVisitDuration(model: IAverageVisitDuration, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/scheduler/setmyaveragevisitduration', model, onSuccess, onError);
    }

    public AddHoliday(model: IHolidays, onSucess: OnRequestSuccess, onError: OnRequestError)  {
        this.Post('api/scheduler/addHoliday', model, onSucess, onError);
    }

    public GetListHolidays(onSucess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/holidays', onSucess, onError);
    }

    public GetListHolidayDays(dateFrom: Date, dateTo: Date, onSucess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/scheduler/holidaydays?dateFrom=' + 
        dateFrom + '&dateTo=' + dateTo, onSucess, onError);
    }

    public EditHoliday(model: IHolidays, onSucess: OnRequestSuccess, onError: OnRequestError)  {
        this.Post('api/scheduler/editHoliday', model, onSucess, onError);
    }

    public DeleteHoliday(id: number, onSucess: OnRequestSuccess, onError: OnRequestError)  {
        this.Post('api/scheduler/deleteHoliday', id, onSucess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/SchedulerService.tsx